<div class="register-verify-page-container">
  <app-register-verify class="z-index--1"></app-register-verify>
  <app-circles-background class="circle-background"></app-circles-background>
</div>
